export function formatHearingType(raw: string): string {
  const cleaned = raw
    .replace(/^FOR /i, '')
    .replace(/^TO /i, '')
    .replace(/ - .+$/, '')
    .replace(/ \(.+\)$/, '')
    .trim();
  
  // Filter out garbage strings (e.g. ~~~~~, =====, or just xxxxx)
  if (/^[\s~=\-_`|.]+$|^[xXoOiI]+$/.test(cleaned)) return '';
  return cleaned;
}
